// extracted by mini-css-extract-plugin
export default {"loading-dots":"SpinnerButton_loading-dots__HSC8N","dot-keyframes":"SpinnerButton_dot-keyframes__fvxB1"};